import GlArea from './GlArea'

export default GlArea
